import request from '@/plugins/ecommerce_axios'
import requestAdmin from '@/plugins/admin_axios'
import { Notification } from '@/plugins/notifications'

export const CreateAffiliate = async (data) => {
  const response = await request.post('/afiliado/create/', data)
  return response.data
}
export const GetAffiliateByUuid = async (affiliate_uuid) => {
  const response = await request.get(`/afiliado/get/${affiliate_uuid}`)
  return response.data
}

export const GetCarrinhoByAfiliado = async (affiliate_uuid, data_inicial, data_final) => {
  let formData = new FormData()
  formData.append('afiliado_uuid', affiliate_uuid)
  formData.append('data_inicial', data_inicial)
  formData.append('data_final', data_final)

  const response = await request.post(`/afiliado/getCarrinhos/`, formData)
  if (response.status != 200) {
    Notification.error(response.data.message || 'Erro ao buscar carrinhos')
    return []
  }
  return response.data.data
}

export const GetAtendimentosByAfiliado = async (affiliate_uuid, data_inicial, data_final) => {
  let formData = new FormData()
  formData.append('afiliado_uuid', affiliate_uuid)
  formData.append('data_inicial', data_inicial)
  formData.append('data_final', data_final)

  const response = await request.post(`/afiliado/getAtendimentos/`, formData)
  if (response.status != 200) {
    Notification.error(response.data.message || 'Erro ao buscar atendimentos')
    return []
  }

  return response.data.data
}
export const UpdateAffiliate = async (affiliateData) => {
  const response = await request.put(`/afiliado/update/`, affiliateData)
  return response.data
}
export const CreateAffiliateContacts = async (affiliateData) => {
  const response = await request.post(`/afiliado/contato/create/`, affiliateData)
  return response.data
}
export const UpdateAffiliateContacts = async (affiliateData) => {
  const response = await request.put(`/afiliado/contato/update/`, affiliateData)
  return response.data
}
export const GetDashboard = async (affiliate_uuid, data_inicial, data_final) => {
  let formData = new FormData()
  formData.append('afiliado_uuid', affiliate_uuid)
  formData.append('data_inicial', data_inicial)
  formData.append('data_final', data_final)

  const response = await request.post('/afiliado/getDashboard/', formData)
  if (response.status != 200) {
    Notification.error(response.data.message || 'Erro ao buscar comissões')
    return []
  }
  return response.data
}

export const GetComissoesByAfiliado = async (affiliate_uuid, data_inicial, data_final) => {
  let formData = new FormData()
  formData.append('afiliado_uuid', affiliate_uuid)
  formData.append('data_inicial', data_inicial)
  formData.append('data_final', data_final)

  const response = await request.post(`/afiliado/getComissoes/`, formData)
  if (response.status != 200) {
    Notification.error(response.data.message || 'Erro ao buscar comissões')
    return []
  }

  return response.data.data
}

export const GetRecuperacaoAfiliado = async (data_inicial, data_final) => {
  let formData = new FormData()
  formData.append('data_inicial', data_inicial)
  formData.append('data_final', data_final)

  const response = await request.post(`/afiliado/recuperacao/`, formData)
  if (response.status != 200) {
    Notification.error(response.data.message || 'Erro ao buscar dados de recuperação')
    return []
  }

  return response.data.data
}

export const ListAfiliados = async (params = {}) => {
  const response = await requestAdmin.get('/afiliado/list/', { params })
  return response
}

export const VincularAfiliado = async (data) => {
  const response = await requestAdmin.put(`/carrinho/vincular-afiliado/`, data)
  return response.data
}

/**
 *
 * @param {FormData} data
 * @returns
 */
export const SaveLayoutAfiliado = async (data) => {
  const options = {
    url: data.get('uuid') ? '/afiliado/layout/update/' : '/afiliado/layout/create/',
    headers : {
      'Content-Type': 'multipart/form-data'
    },
    method: data.get('uuid') ? 'put' : 'post',
    data: data
  }
  const response = await request.request(options)
  return response.data
  }

  export const GetVitrineGerenciamento = async (data) => {
  const response = await request.post('/afiliado/vitrine/gerenciar/', data)
  return response.data
  }

  export const ToggleProductVisibility = async (data) => {
  const response = await request.post('/afiliado/vitrine/produto/toggle/', data)
  return response.data
  }

  export const TogglePromotionVisibility = async (data) => {
  const response = await request.post('/afiliado/vitrine/promocao/toggle/', data)
  return response.data
  }